import React from 'react'
import './SavedJob.css'
import JobCards from './JobCards'


export default function SavedJob() {

    return ( <>
        <div className='appliendJob_main'>
            <div className='applied-job-cards'>
                <JobCards />
            </div>
        </div>
    </> );
}

